import { render, staticRenderFns } from "./MainChatWindow.vue?vue&type=template&id=7ce66be9&"
import script from "./MainChatWindow.vue?vue&type=script&lang=js&"
export * from "./MainChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./MainChatWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports